// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1gq7v","col":"styles_col__3QsA2"};